import { api } from "@/lib/api";
import { type Schemas } from "@/types";
import { useQuery } from "react-query";

export default function OpenLeadsListQuery() {
  const { data } = useQuery({
    queryKey: ["openLeadsListStats"],
    queryFn: async () => {
      const response = await api.get<Schemas["OpenLeadsListStats"]>(
        "/api/Reports/OpenLeadsListStats",
      );
      return response.data;
    },
  });

  return {
    leads: data?.leads ?? [],
  };
}
